import React from 'react';
import { Button } from 'semantic-ui-react';

const FloatingVerifyButton = ({ loading, onClick }) => (
    <div style={{ position: 'fixed', bottom: 90, right: 72, zIndex: 9999 }}>
        <Button
            primary
            circular
            icon='check circle'
            size='large'
            onClick={onClick}
            disabled={loading}
            title="Verify Total Pay matches across CDP Report, Sage Export, and Earnings Report"
            style={{ boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}
        />
    </div>
);

export default FloatingVerifyButton;
